import { Link } from "react-router-dom";
import { useEffect } from "react";
import "./AboutUs.css";

// component trang giới thiệu công ty
const AboutUs = () => {
  useEffect(() => {
    document.title = "Giới thiệu Mễ Mễ";
  });

  return (
    <section className="about-us">
      <nav aria-label="breadcrumb">
        <ol
          style={{ "--bs-breadcrumb-bg": "#f0f0f0" }}
          className="breadcrumb  ps-3 pt-2 pb-3 mb-0 "
        >
          <li className="breadcrumb-item">
            <Link to="/">Trang chủ</Link>
          </li>
          <li className="breadcrumb-item">Giới thiệu</li>
        </ol>
      </nav>

      <div className="row mb-5 mt-3 border-bottom p-3 ">
        <div className="col-12 col-sm-4 col-lg-4 text-center">
          <img
            style={{ width: "90%" }}
            src="./images/img_home_fresh.webp"
            alt="meme_home"
          />
        </div>

        <div className="col-12 col-sm-8 col-lg-8 text-muted fst-italic ">
          <p className="text-uppercase text-success fw-bold fs-3 ps-3">
            Giới thiệu Mễ Mễ Việt Nam
          </p>
          <p className="fw-bold">Kính gửi: Quý khách hàng!</p>
          <p>
            Công ty Cổ Phần Thương Mại Dịch Vụ WMA xin chân thành kính chúc quý
            khách hàng và gia đình an khang thịnh vượng. WMA trân trọng cảm ơn
            quý khách hàng đã quan tâm và lựa chọn sản phẩm mang thương hiệu Mễ
            Mễ của chúng tôi. <br /> <br />
            Xuất phát từ những nhà sáng lập và đội ngũ nhân sự phần đông là
            những người phụ nữ với mục tiêu không ngừng phát triển bản thân đồng
            thời cân bằng tốt giữa công việc và cuộc sống gia đình, chúng tôi{" "}
            <strong>
              đồng cảm và thấu hiểu những cung bậc cảm xúc của phụ nữ Việt trên
              hành trình làm mẹ
            </strong>
            . Từ sự thấu hiểu đó, toàn bộ đội ngũ WMA khát khao được lắng nghe
            và đồng hành với mỗi phụ nữ Việt trên hành trình nhiều hạnh phúc mà
            cũng nhiều gian nan này. Đồng thời, WMA cam kết đem đến nhiều sản
            phẩm <strong>lành - chất như gạo</strong> cùng những dịch vụ tận tâm
            đến từng bà mẹ, từng em bé, từng gia đình Việt. Bởi vì với Mễ Mễ,
            mọi phụ nữ mọi trẻ em đều xứng đáng được yêu thương và nâng niu.{" "}
            <br /> <br />
            Một lần nữa, kính chúc quý khách hàng An lành và Hạnh phúc!
          </p>
          <div className="w-50 float-end text-end">
            <p className="text-center">Trân trọng và biết ơn.</p>
            <p className="text-center fw-bold fst-normal text-success">
              Công ty Cổ Phần Thương Mại Dịch Vụ WMA
            </p>
          </div>
        </div>
      </div>

      <div className="row p-3 text-muted">
        <div className="col-12 col-md-4 col-lg-4">
          <p className="fs-5 fw-bold text-center">
            Ý nghĩa của tên thương hiệu
          </p>
          <p>
            Mễ Mễ trong tiếng Hán Việt có nghĩa là “Gạo” - với thông điệp “lành,
            chất” như mỗi hạt gạo quê hương - chắt chiu từng chút từng chút dinh
            dưỡng, để nuôi lớn bé yêu nên người. Mễ Mễ, Me Me, Mẹ Mẹ - cũng là
            những tiếng đầu bi bô khi con tập nói
          </p>
        </div>
        <div className="col-12 col-md-4 col-lg-4">
          <div className="d-flex gap-3 justify-content-center align-items-center mb-3">
            <img
              style={{ width: "5vw" }}
              src="./images/info_icon_2_about2.webp"
              alt="icon_meme"
            />
            <p className="fs-5 fw-bold text-center">Ý nghĩa của biểu tượng</p>
          </div>
          <p>
            <strong>Logo</strong> của Mễ Mễ được cách điệu từ hình ảnh 02 hạt
            gạo. Hạt gạo lớn - Đại Mễ - là biểu trưng cho người mẹ. Hạt gạo nhỏ
            - Tiểu Mễ - là biểu trưng cho bé yêu. Trong tư thế mẹ bồng con, hai
            hạt gạo ghép lại thành hình trái tim mang ý nghĩa yêu thương luôn
            đong đầy. Logo được tạo khối tròn cong với 02 lá mầm ở trên hình
            trái tim hạt gạo. Đây là sự cách điệu từ hình ảnh em bé trong bụng
            bầu của mẹ, luôn được chở che bởi những yêu thương từ trái tim và
            được bảo vệ bởi những điều mát lành nhất từ mầm lá. Trên tất cả,
            hình ảnh của logo là một triết lý “phục vụ” mà Mễ Mễ muốn mang tới
            cho các Tiểu Mễ - “những mầm non tương lai” - từ những sản phẩm cơ
            bản, giản dị và “lành, chất” nhất.
          </p>
        </div>
        <div className="col-12 col-md-4 col-lg-4">
          <p className="fs-5 fw-bold text-center">Ý nghĩa của câu khẩu hiệu</p>
          <p>
            "Thấu hiểu hành trình làm mẹ", làm mẹ là một hành trình của sự tìm
            tòi, hi sinh và Mễ Mễ thấu hiểu điều đó. Với sứ mệnh của mình, qua
            từng sản phẩm dịch vụ, Mễ Mễ muốn được gửi gắm tâm huyết và tình yêu
            thương để được đồng hành, sẻ chia.
          </p>
        </div>
      </div>

      <div className="text-center mt-5">
        <p className="text-uppercase text-success fst-italic fw-bold fs-4">
          Đánh giá về Mễ Mễ
        </p>
        <p className="text-muted fst-italic fs-5 ms-5 me-5">
          Mễ Mễ hân hạnh được đồng hành cùng các tổ chức uy tín trong lĩnh vực
          chăm sóc Mẹ và Bé. Chúng tôi không ngừng nỗ lực hoàn thiện để nhận
          được sự công nhận từ người tiêu dùng và các tổ chức truyền thông.
        </p>

        <div className="row">
          <div className="col-12 col-md-4 col-lg-4">
            <Link
              className="text-center text-decoration-none"
              to="https://bau.vn/me-me-viet-nam-tung-bung-ki-niem-1-nam-thanh-lap-nam-qua-dung-me-me-me-cham-be-nhan-ghe/"
              target="_blank"
            >
              <img
                style={{ width: "70%" }}
                src="./images/media/members_img_1_about2.webp"
                alt="bau_1_meme"
              />
              <p className="fs-5">Truyền thông nói về Mễ Mễ</p>
            </Link>
          </div>

          <div className="col-12 col-md-4 col-lg-4">
            <Link
              className="text-center text-decoration-none"
              to="https://www.youtube.com/watch?v=x_TY1WPPCWY"
              target="_blank"
            >
              <img
                style={{ width: "70%" }}
                src="./images/media/members_img_2_about2.webp"
                alt="bau_1_meme"
              />
              <p className="fs-5 text-center">
                Mễ Mễ đồng hành cùng chương trình Vì Trẻ Em
              </p>
            </Link>
          </div>

          <div className="col-12 col-md-4 col-lg-4">
            <Link
              className="text-center text-decoration-none"
              to="https://dantri.com.vn/doi-song/me-me-thuong-hieu-viet-nam-duoc-cac-gia-dinh-tin-dung-20220423130746400.htm"
              target="_blank"
            >
              <img
                style={{ width: "70%" }}
                src="./images/media/members_img_4_about2.webp"
                alt="bau_1_meme"
              />
              <p className="fs-5">Báo Dân Trí nói về Mễ Mễ</p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutUs;
